import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { ResultPlantView } from "./resultplant-view";

export const ResultPlantController = (props) => {

	const getLastItem = (thePath) => thePath.substring(thePath.lastIndexOf("/") + 1);
	const slug = getLastItem(window.location.pathname);
	const [results, setResults] = useState([]);
	// const [buyresult, setBuyresult] = useState();
	const [refresh, setRefresh] = useState("");
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	// console.log(props);
	
	const gid = (g)=>{
		// alert("hello1");
		setnewGroupid(g)
		console.log(g);
	}
	const [newgroupid, setnewGroupid] = useState();
	
	// const slug = "verynewplant";

	useEffect(() => {
		props.handleExpandFal();
		// console.log(props.handleExpandFal());
		serviceProvider.post("/home?type=setfirstresultseen", JSON.stringify({ uid: usid }),true).then((response) => {
			// console.log(response);
		});
		if(newgroupid){
			const search = async () => {
				const apiUrl = `/resultsmaturityassess?param=result&uid=${usid}&slug=${slug}&gid=${newgroupid}`;
				const { data } = await serviceProvider.get(apiUrl,true,{});
				setResults(data);
				//console.log("hello1");
			};
			search();
	}else{
		const search = async () => {
			const apiUrl = `/resultsmaturityassess?param=result&uid=${usid}&slug=${slug}&gid=12`;
			const { data } = await serviceProvider.get(apiUrl,true,{});
			
			setResults(data);
			//console.log("hello2");
		};
		search();
	}

	}, [newgroupid]);
	
	
	
	if (results.length) {
				
		return <ResultPlantView groupid={gid} ggid={newgroupid}  resultsData={results} {...props} />;


	}else{
					return (
					<>
						<div></div>
					</>
				);
		}



};
